/**
 * Agent withdraw unlock UI strings (loading + requirement met + min deposit hint).
 * Imported into each locale file alongside panelAgentWithdrawByLang.
 */
export const panelAgentWithdrawUnlockStringsByLang = {
  es: {
    'agent.withdraw.unlock.loadingTitle': 'Comprobando estado de retiros…',
    'agent.withdraw.unlock.loadingSubtitle':
      'Cargando tu progreso de referidos y requisitos de desbloqueo',
    'agent.withdraw.form.loadingTitle': 'Cargando datos de retiro…',
    'agent.withdraw.form.loadingHint': 'Espera mientras cargamos tu saldo y estado de desbloqueo',
    'agent.withdraw.unlock.requirementMet': 'Requisito cumplido',
    'agent.withdraw.unlock.minDepositHint':
      'Solo cuentan usuarios referidos (no sub-agentes). Cada uno debe tener al menos ${{amount}} en depósitos completados.',
  },
  de: {
    'agent.withdraw.unlock.loadingTitle': 'Auszahlungsstatus wird geprüft…',
    'agent.withdraw.unlock.loadingSubtitle':
      'Empfehlungsfortschritt und Freischaltungsanforderungen werden geladen',
    'agent.withdraw.form.loadingTitle': 'Auszahlungsdetails werden geladen…',
    'agent.withdraw.form.loadingHint':
      'Bitte warten — Guthaben und Freischaltungsstatus werden geladen',
    'agent.withdraw.unlock.requirementMet': 'Anforderung erfüllt',
    'agent.withdraw.unlock.minDepositHint':
      'Nur geworbene Nutzer (keine Sub-Agenten). Mindestens ${{amount}} abgeschlossene Einzahlungen pro Nutzer.',
  },
  fr: {
    'agent.withdraw.unlock.loadingTitle': 'Vérification du statut des retraits…',
    'agent.withdraw.unlock.loadingSubtitle':
      'Chargement de votre progression de parrainage et des exigences',
    'agent.withdraw.form.loadingTitle': 'Chargement des détails de retrait…',
    'agent.withdraw.form.loadingHint':
      'Veuillez patienter pendant le chargement du solde et du statut',
    'agent.withdraw.unlock.requirementMet': 'Exigence remplie',
    'agent.withdraw.unlock.minDepositHint':
      'Seuls les utilisateurs parrainés comptent (pas les sous-agents). Chacun doit avoir au moins ${{amount}} de dépôts complétés.',
  },
  ar: {
    'agent.withdraw.unlock.loadingTitle': 'جاري التحقق من حالة السحب…',
    'agent.withdraw.unlock.loadingSubtitle': 'جاري تحميل تقدم الإحالات ومتطلبات فتح السحب',
    'agent.withdraw.form.loadingTitle': 'جاري تحميل تفاصيل السحب…',
    'agent.withdraw.form.loadingHint': 'يرجى الانتظار أثناء تحميل الرصيد وحالة فتح السحب',
    'agent.withdraw.unlock.requirementMet': 'تم استيفاء الشرط',
    'agent.withdraw.unlock.minDepositHint':
      'يُحسب المستخدمون المُحالون فقط (وليس الوكلاء الفرعيون). يجب أن يكون لكل مستخدم ${{amount}} على الأقل من الإيداعات المكتملة.',
  },
  ja: {
    'agent.withdraw.unlock.loadingTitle': '出金ステータスを確認中…',
    'agent.withdraw.unlock.loadingSubtitle': '紹介の進捗と解除要件を読み込んでいます',
    'agent.withdraw.form.loadingTitle': '出金情報を読み込み中…',
    'agent.withdraw.form.loadingHint': '残高と解除ステータスの読み込みが完了するまでお待ちください',
    'agent.withdraw.unlock.requirementMet': '要件を達成',
    'agent.withdraw.unlock.minDepositHint':
      '紹介ユーザーのみが対象（サブエージェントは除く）。各ユーザーは完了済み入金が少なくとも ${{amount}} 必要です。',
  },
  ko: {
    'agent.withdraw.unlock.loadingTitle': '출금 상태 확인 중…',
    'agent.withdraw.unlock.loadingSubtitle': '추천 진행 상황 및 해제 요건을 불러오는 중입니다',
    'agent.withdraw.form.loadingTitle': '출금 정보 불러오는 중…',
    'agent.withdraw.form.loadingHint': '잔액 및 해제 상태를 불러올 때까지 잠시 기다려 주세요',
    'agent.withdraw.unlock.requirementMet': '요건 충족',
    'agent.withdraw.unlock.minDepositHint':
      '추천 사용자만 해당됩니다(하위 에이전트 제외). 각 사용자는 완료된 입금이 최소 ${{amount}} 이상이어야 합니다.',
  },
  'zh-CN': {
    'agent.withdraw.unlock.loadingTitle': '正在检查提现状态…',
    'agent.withdraw.unlock.loadingSubtitle': '正在加载您的推荐进度和解锁要求',
    'agent.withdraw.form.loadingTitle': '正在加载提现详情…',
    'agent.withdraw.form.loadingHint': '请稍候，正在加载余额和解锁状态',
    'agent.withdraw.unlock.requirementMet': '已满足要求',
    'agent.withdraw.unlock.minDepositHint':
      '仅统计推荐用户（不含下级代理）。每位用户须至少有 ${{amount}} 已完成入金。',
  },
  pt: {
    'agent.withdraw.unlock.loadingTitle': 'Verificando status de saque…',
    'agent.withdraw.unlock.loadingSubtitle':
      'Carregando seu progresso de indicações e requisitos de desbloqueio',
    'agent.withdraw.form.loadingTitle': 'Carregando detalhes do saque…',
    'agent.withdraw.form.loadingHint': 'Aguarde enquanto carregamos seu saldo e status de desbloqueio',
    'agent.withdraw.unlock.requirementMet': 'Requisito atendido',
    'agent.withdraw.unlock.minDepositHint':
      'Apenas usuários indicados contam (não sub-agentes). Cada um precisa de pelo menos ${{amount}} em depósitos concluídos.',
  },
  it: {
    'agent.withdraw.unlock.loadingTitle': 'Verifica stato prelievi…',
    'agent.withdraw.unlock.loadingSubtitle': 'Caricamento progresso referral e requisiti di sblocco',
    'agent.withdraw.form.loadingTitle': 'Caricamento dettagli prelievo…',
    'agent.withdraw.form.loadingHint': 'Attendere il caricamento del saldo e dello stato di sblocco',
    'agent.withdraw.unlock.requirementMet': 'Requisito soddisfatto',
    'agent.withdraw.unlock.minDepositHint':
      'Contano solo gli utenti referenziati (non i sub-agent). Ognuno deve avere almeno ${{amount}} in depositi completati.',
  },
  ru: {
    'agent.withdraw.unlock.loadingTitle': 'Проверка статуса вывода…',
    'agent.withdraw.unlock.loadingSubtitle':
      'Загрузка прогресса рефералов и требований для разблокировки',
    'agent.withdraw.form.loadingTitle': 'Загрузка данных о выводе…',
    'agent.withdraw.form.loadingHint': 'Подождите, загружаем баланс и статус разблокировки',
    'agent.withdraw.unlock.requirementMet': 'Требование выполнено',
    'agent.withdraw.unlock.minDepositHint':
      'Учитываются только приглашённые пользователи (не суб-агенты). У каждого должно быть не менее ${{amount}} завершённых депозитов.',
  },
  bn: {
    'agent.withdraw.unlock.loadingTitle': 'উত্তোলনের অবস্থা যাচাই করা হচ্ছে…',
    'agent.withdraw.unlock.loadingSubtitle': 'আপনার রেফারেল অগ্রগতি ও আনলক শর্ত লোড হচ্ছে',
    'agent.withdraw.form.loadingTitle': 'উত্তোলনের বিবরণ লোড হচ্ছে…',
    'agent.withdraw.form.loadingHint': 'ব্যালেন্স ও আনলক অবস্থা লোড হওয়া পর্যন্ত অপেক্ষা করুন',
    'agent.withdraw.unlock.requirementMet': 'শর্ত পূরণ হয়েছে',
    'agent.withdraw.unlock.minDepositHint':
      'শুধু রেফার করা ব্যবহারকারী গণনা হয় (সাব-এজেন্ট নয়)। প্রত্যেকের সম্পন্ন জমা কমপক্ষে ${{amount}} হতে হবে।',
  },
  hi: {
    'agent.withdraw.unlock.loadingTitle': 'निकासी स्थिति जाँची जा रही है…',
    'agent.withdraw.unlock.loadingSubtitle': 'आपकी रेफरल प्रगति और अनलॉक आवश्यकताएँ लोड हो रही हैं',
    'agent.withdraw.form.loadingTitle': 'निकासी विवरण लोड हो रहे हैं…',
    'agent.withdraw.form.loadingHint': 'कृपया प्रतीक्षा करें — बैलेंस और अनलॉक स्थिति लोड हो रही है',
    'agent.withdraw.unlock.requirementMet': 'आवश्यकता पूरी',
    'agent.withdraw.unlock.minDepositHint':
      'केवल रेफ़र किए गए उपयोगकर्ता गिने जाते हैं (उप-एजेंट नहीं)। प्रत्येक के पास पूर्ण जमा में कम से कम ${{amount}} होना चाहिए।',
  },
};
